import _objectWithoutProperties from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Component } from 'react';
import Hls from 'hls.js/dist/hls.light.min';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createMasterM3U8(list) {
  var result = [];
  result.push('#EXTM3U');
  list.forEach(function (item) {
    var meta = {
      'PROGRAM-ID': '1',
      BANDWIDTH: String(item.bandwidth)
    };

    if (item.resolution) {
      var _item$resolution = item.resolution,
          width = _item$resolution.width,
          height = _item$resolution.height;
      meta.RESOLUTION = "".concat(width, "x").concat(height);
    }

    result.push("#EXT-X-STREAM-INF:".concat(Object.entries(meta).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return "".concat(key, "=").concat(value);
    }).join(',')));
    result.push(item.source);
  });
  return result.join('\n');
}

var getMasterM3U8Blob = function getMasterM3U8Blob(sources) {
  var list = sources.map(function (item) {
    return {
      source: item.source,
      bandwidth: item.bitrate * 1024,
      resolution: {
        width: item.width,
        height: item.height
      }
    };
  });
  return new Blob([createMasterM3U8(list)], {
    type: 'application/vnd.apple.mpegURL'
  });
};

var Video =
/*#__PURE__*/
function (_Component) {
  _inherits(Video, _Component);

  function Video() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Video)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "hasLoadStarted", false);

    return _this;
  }

  _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.hls = new Hls({
        autoStartLoad: false
      });
      this.hls.attachMedia(this.video);
      var sources = this.props.sources;
      var master = getMasterM3U8Blob(sources);
      this.src = URL.createObjectURL(master);
      this.hls.loadSource(this.src);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          currentQuality = _this$props.currentQuality,
          sources = _this$props.sources,
          paused = _this$props.paused;

      if (currentQuality !== prevProps.currentQuality) {
        var source = sources.find(function (source) {
          return source.quality === currentQuality;
        });

        if (source) {
          var levels = this.hls.levels;
          var level = levels.findIndex(function (item) {
            return item.url.includes(source.source);
          });
          this.hls.nextLevel = level;
        } else {
          this.hls.nextLevel = -1;
        }
      }

      if (!paused && prevProps.paused && !this.hasLoadStarted) {
        this.hls.startLoad();
        this.hasLoadStarted = true;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hls.destroy();
      URL.revokeObjectURL(this.src);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          onRef = _this$props2.onRef,
          currentQuality = _this$props2.currentQuality,
          src = _this$props2.src,
          sources = _this$props2.sources,
          paused = _this$props2.paused,
          props = _objectWithoutProperties(_this$props2, ["onRef", "currentQuality", "src", "sources", "paused"]);

      return React.createElement("video", _extends({
        ref: function ref(el) {
          if (onRef) {
            onRef(el);
          }

          _this2.video = el;
        }
      }, props));
    }
  }]);

  return Video;
}(Component);

var index = {
  pluginName: 'griffith-hls',
  VideoComponent: Video,
  willHandleSrcChange: true
};
export default index;